<template>
  <div
    v-if="!_isEmpty(comment) || documents?.length"
    class="flex flex-col grow gap-2 mt-0.5 text-secondary text-style-sm bg-gradient-gray-neutral border border-secondary rounded-sm px-3 py-2.5 overflow-hidden"
  >
    <div v-if="!_isEmpty(comment)" v-html="comment" />
    <div
      class="flex flex-col grow gap-2 overflow-hidden"
      v-if="documents.length > 0"
    >
      <File
        v-for="document in documents"
        :key="document.id"
        :file="document"
        :preview="isSupportedMedia(document.mime_type)"
        :download="true"
        :color="_isEmpty(comment) ? 'transparent' : 'white'"
        :border="!_isEmpty(comment) || documents.length > 1"
        @preview="$emit('preview', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { isEmpty } from "lodash";
import Link from "@tiptap/extension-link";
import Mention from "@tiptap/extension-mention";
import { generateHTML } from "@tiptap/html";
import StarterKit from "@tiptap/starter-kit";
import { File } from "@/SharedComponents/Files";
import { isSupportedMedia } from "@/SharedComponents/Media";

defineEmits(["preview"]);

const props = defineProps({
  item: { type: Object, required: true },
});

const comment = computed(() => {
  if (!props.item.comment?.contents || isEmpty(props.item.comment?.contents)) {
    return "";
  }

  return generateHTML(props.item.comment.contents, [
    StarterKit,
    Link,
    Mention.configure({
      HTMLAttributes: {
        class: "before:content-['@'] font-semibold text-brand-tertiary",
      },
      renderLabel({ node }) {
        return `${node.attrs.label ?? node.attrs.id}`;
      },
    }),
  ]);
});

function _isEmpty(html) {
  const div = document.createElement("div");
  div.innerHTML = html.trim();

  if (div.innerHTML === "" || div.innerHTML === "<p></p>") {
    return true;
  }

  return div.textContent.trim().length === 0;
}

const documents = computed(() => {
  return props.item.comment?.documents || [];
});
</script>
